<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  diameter: number;
  progress: number;
  strokeWidth: number;
  strokeColor: string;
  innerStrokeWidth: number;
  innerStrokeColor: string;
}>();

const radius = computed(() => props.diameter / 2);
const innerCircleDiameter = computed(() => props.diameter - props.innerStrokeWidth * 2);
const innerCircleRadius = computed(() => innerCircleDiameter.value / 2);
const circumference = computed(() => innerCircleDiameter.value * Math.PI);
const strokeDashoffset = computed(
  () => circumference.value - (props.progress / 100) * circumference.value,
);

const strokeStyle = computed(() => ({
  height: `${props.diameter}px`,
  width: `${props.diameter}px`,
  strokeWidth: `${props.innerStrokeWidth}px`,
}));

const progressStyle = computed(() => ({
  height: `${props.diameter}px`,
  width: `${props.diameter}px`,
  strokeWidth: `${props.strokeWidth}px`,
  strokeDashoffset: strokeDashoffset.value,
  transition: "stroke-dashoffset 1s ease-out",
}));
</script>

<template>
  <svg :width="diameter" :height="diameter" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <circle
      :r="innerCircleRadius"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      :stroke="innerStrokeColor"
      :stroke-dasharray="circumference"
      stroke-dashoffset="0"
      stroke-linecap="round"
      :style="strokeStyle"
    />

    <circle
      :transform="`rotate(270, ${radius},${radius})`"
      :r="innerCircleRadius"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      :stroke="strokeColor"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="circumference"
      stroke-linecap="round"
      :style="progressStyle"
    />
  </svg>
</template>
